module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.ee653992.ttf";